import React, { useEffect, useState } from "react";
import MessageBar, {
  config,
  errorNotify,
  getValueFromLocalStorage,
  localStorageKey,
  successNotify,
} from "../../../utils/helper";
import Images from "../../../utils/images";
import UserRequestCard from "../../../Components/UserRequestCard/UserRequestCard";
import {
  authorizedGet,
  authorizedPost,
} from "../../../Config/networkWithToken";
import configuration from "../../../Config/configuration";
import Spinner from "../../../Components/Spinner/Spinner";
import Strings from "../../../utils/Strings";
import { ImCancelCircle } from "react-icons/im";
import AdvanceSearch from "../../../Components/AdvanceSearch/AdvanceSearch";
import { IoIosSearch } from "react-icons/io";

const QuestionnaireRequests = () => {
  const adminId = getValueFromLocalStorage(localStorageKey.USERDATA, "adminId");
  const [activeTab, setActiveTab] = useState(0);
  const [userRequests, setUserRequests] = useState([]);
  const [acceptedRequest, setAcceptedRequest] = useState([]);
  const [rejectedRequest, setRejectedRequest] = useState([]);
  const [loading, setLoading] = useState(true);
  const [LoadingId, setLoadingId] = useState(false);
  const [filter, setFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [requests, setRequests] = useState([]);
  useEffect(() => {
    getUserQuestionnaireRequests();
  }, []);

  const tabList = [
    { name: "User Requests", count: userRequests.length },
    { name: "Accepted Requests", count: acceptedRequest.length },
    { name: "Denied Requests", count: rejectedRequest.length },
  ];

  const getUserQuestionnaireRequests = async () => {
    setLoading(true);
    try {
      const res = await authorizedGet(
        `${configuration.apis.getAllQuestionnaireRequests}?adminId=${adminId}`,
        config,
      );
      const response = res?.data?.requests;
      if (res?.data?.status) {
        const users = [];
        const accpted = [];
        const rejected = [];
        setRequests(response);
        response.forEach((value) => {
          if (value?.adminApproval === "pending") {
            users.push(value);
          } else if (value?.adminApproval === "approved") {
            accpted.push(value);
          } else if (value?.adminApproval === "rejected") {
            rejected.push(value);
          }
        });

        setUserRequests(users);
        setAcceptedRequest(accpted);
        setRejectedRequest(rejected);
        console.log("Response", requests);
      }
    } catch (error) {
      errorNotify(Strings.ERROR);
    } finally {
      setLoading(false);
    }
  };

  const handleApproval = async (reqId, decision) => {
    setLoadingId(reqId);
    try {
      const data = {
        reqId: reqId,
        action: decision,
      };
      const res = await authorizedPost(
        configuration.apis.questionnaireApproval,
        data,
        config,
      );
      const response = res?.data?.data;
      console.log(response);
      if (res?.data?.status) {
        successNotify(res?.data?.message);
        const users = [];
        const accpted = [];
        const rejected = [];

        response.forEach((value) => {
          if (value?.adminApproval === "pending") {
            users.push(value);
          } else if (value?.adminApproval === "approved") {
            accpted.push(value);
          } else if (value?.adminApproval === "rejected") {
            rejected.push(value);
          }
        });

        setUserRequests(users);
        setAcceptedRequest(accpted);
        setRejectedRequest(rejected);
      } else {
        errorNotify(res?.data?.message);
      }
    } catch (error) {
      console.log(
        "Error in approval:",
        error.response ? error.response.data : error,
      );
      errorNotify("Error processing request.");
    } finally {
      setLoadingId(null);
    }
  };

  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const handleAdvanceSearch = (searchValue) => {
    const query = searchValue.toLowerCase().trim();
    setSearchQuery(query);
    let search = [];

    if (activeTab === 0) {
      search = userRequests?.filter((user) => {
        const userName = user?.user?.name?.toLowerCase() || "";
        const requestedUserName =
          user?.requestedUser?.name?.toLowerCase() || "";
        return userName.includes(query) || requestedUserName.includes(query);
      });
      setUserRequests(search);
      setSearchData(search);
    } else if (activeTab === 1) {
      search = acceptedRequest?.filter((user) => {
        const userName = user?.user?.name?.toLowerCase() || "";
        const requestedUserName =
          user?.requestedUser?.name?.toLowerCase() || "";

        return userName.includes(query) || requestedUserName.includes(query);
      });
      setSearchData(search);
      setAcceptedRequest(search);
    } else if (activeTab === 2) {
      search = rejectedRequest?.filter((user) => {
        const userName = user?.user?.name?.toLowerCase() || "";
        const requestedUserName =
          user?.requestedUser?.name?.toLowerCase() || "";

        return userName.includes(query) || requestedUserName.includes(query);
      });
      setRejectedRequest(search);
      setSearchData(search);
      console.log("Search", search);
    }
  };
  const toggleSearchBar = () => {
    setShowAdvanceSearch((prev) => !prev);
    setSearchQuery("");
    setSearchData([]);
    if (showAdvanceSearch) {
      setData(requests);
    }
  };
  const filterRequests = (value) => {
    const today = new Date();
    setFilter(value);

    let sortedData;
    let data = [];

    if (searchData.length > 0) {
      data = searchData;
    } else if (searchQuery && searchData.length === 0) {
      data = [];
    } else if (requests.length > 0) {
      data = requests;
    } else {
      data = requests;
    }
     if (value === "all") {
    setData(data);
     return;
    } else {
      const sortData = data?.filter((user) => {
        if (!user || !user.sentAt) return false;

        const requestDate = new Date(user.sentAt);
        const diffTime = today.getTime() - requestDate.getTime();
        const diffDays = diffTime / (1000 * 60 * 60 * 24);
        if (value === "today")
          return requestDate.toDateString() === today.toDateString();
        if (value === "week") return diffDays < 7 && diffDays >= 0;
        if (value === "month")
          return (
            requestDate.getMonth() === today.getMonth() &&
            requestDate.getFullYear() === today.getFullYear()
          );
        if (value === "year")
          return requestDate.getFullYear() === today.getFullYear();

        return false;
      });

      sortedData = sortData.sort(
        (a, b) => new Date(b.sentAt) - new Date(a.sentAt),
      );
    }
    setData(sortedData);
    console.log("sortedData",sortedData);
  };

  const setData = (data) => {
    const users = [];
    const accpted = [];
    const rejected = [];
    data?.forEach((value) => {
      if (value?.adminApproval === "pending") {
        users.push(value);
      } else if (value?.adminApproval === "approved") {
        accpted.push(value);
      } else if (value?.adminApproval === "rejected") {
        rejected.push(value);
      }
    });

    setUserRequests(users);
    setAcceptedRequest(accpted);
    setRejectedRequest(rejected);
  };

  return (
    <div className="font-jost relative ml-4 h-auto rounded-lg p-2">
      {/* Tabs */}
      <div className="flex w-full items-center justify-center text-xs text-gray-400 md:justify-end">
        Note: The details are sorted by the date the request was sent.
      </div>
      <div className="flex w-full flex-col justify-between border-b border-gray-300  md:flex-row">
        <ul className="flex flex-col justify-center md:flex-row">
          {tabList.map((list, index) => (
            <li
              key={index}
              className={`mt-3 cursor-pointer px-4 py-2 text-center text-textGreen transition-all ${showAdvanceSearch ? "text-[13px] xl:text-[16px]" : "sm:text-xs md:text-base"} 
                    ${
                      activeTab === index
                        ? "border-b-2 border-textYellow text-textYellow "
                        : "hover:bg-gray-100 hover:text-textYellow"
                    }`}
              onClick={() => handleTabClick(index)}
            >
              {list.name}({list.count})
            </li>
          ))}
        </ul>
        <div className="flex flex-wrap items-center justify-center">
          {/* Search and Sort  */}
          <div className="flex flex-row items-center gap-2 ">
            {/* Search Icon & Advanced Search */}
            <div className="flex items-center rounded-lg ">
              {!showAdvanceSearch ? (
                <IoIosSearch
                  className="cursor-pointer text-xl text-gray-500 sm:text-2xl"
                  onClick={toggleSearchBar}
                />
              ) : (
                <div className="flex items-center gap-2">
                  <AdvanceSearch onSearchValue={handleAdvanceSearch} />
                  <ImCancelCircle
                    className="cursor-pointer text-lg text-gray-500 sm:text-xl"
                    onClick={toggleSearchBar}
                  />
                </div>
              )}
            </div>
            <div className="flex flex-col items-center">
              <p className="text-xs">sort by:</p>
              <select
                className="rounded-md border px-1 py-1 text-xs"
                value={filter}
                onChange={(e) => filterRequests(e.target.value)}
              >
                <option value="all">All</option>
                <option value="today">Today</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
                <option value="year">This Year</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="flex min-h-screen flex-col items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <>
          {activeTab === 0 && (
            <div className="flex flex-wrap gap-4">
              {userRequests.length > 0 ? (
                userRequests.map((request) => (
                  <UserRequestCard
                    key={request?._id}
                    user={request?.user}
                    requestedUser={request?.requestedUser}
                    activeTab={activeTab}
                    reqId={request?._id}
                    setUserRequests={setUserRequests}
                    setAcceptedRequest={setAcceptedRequest}
                    setRejectedRequest={setRejectedRequest}
                  />
                ))
              ) : (
                <p className="w-full text-center ">
                  No Questionnaire requests available.
                </p>
              )}
            </div>
          )}

          {activeTab === 1 && (
            <div className="flex flex-wrap gap-4">
              {acceptedRequest.length > 0 ? (
                acceptedRequest.map((request) => (
                  <UserRequestCard
                    key={request?._id}
                    user={request?.user}
                    requestedUser={request?.requestedUser}
                    activeTab={activeTab}
                    setUserRequests={setUserRequests}
                    setAcceptedRequest={setAcceptedRequest}
                    setRejectedRequest={setRejectedRequest}
                  />
                ))
              ) : (
                <p className="w-full text-center ">
                  No Accepted requests available.
                </p>
              )}
            </div>
          )}

          {activeTab === 2 && (
            <div className="flex flex-wrap gap-4">
              {rejectedRequest.length > 0 ? (
                rejectedRequest.map((request) => (
                  <UserRequestCard
                    key={request?._id}
                    user={request?.user}
                    requestedUser={request?.requestedUser}
                    activeTab={activeTab}
                    setUserRequests={setUserRequests}
                    setAcceptedRequest={setAcceptedRequest}
                    setRejectedRequest={setRejectedRequest}
                  />
                ))
              ) : (
                <p className="w-full text-center ">
                  No Rejected requests available.
                </p>
              )}
            </div>
          )}
        </>
      )}
      <MessageBar />
    </div>
  );
};

export default QuestionnaireRequests;
